import React, { useState, useEffect, useCallback } from "react";
import { ImCross } from "react-icons/im";
import { useParams, Link } from "react-router-dom";
import Loading from "../components/Loading/Loading";
import Article from "../components/SingleCocktail/Article";
import "../components/SingleCocktail/Single.css";

const url = "https://www.thecocktaildb.com/api/json/v1/1/lookup.php?i=";

const SingleCocktail = () => {
  const { id } = useParams();
  // console.log(id);
  const [loading, setLoading] = useState(false);
  const [cocktails, setCocktails] = useState([]);
  const [isClicked, setIsClicked] = useState(false);

  const FetchingData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await fetch(`${url}${id}`);
      const jsonResponse = await response.json();
      // console.log(jsonResponse);
      const { drinks } = jsonResponse;
      if (drinks) {
        const {
          strAlcoholic: type,
          strCategory: category,
          strDrink: name,
          strGlass: glass,
          strDrinkThumb: img,
          strInstructions: Instructions,
          strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,
        } = drinks[0];
        const Ingredients = [
          strIngredient1,
          strIngredient2,
          strIngredient3,
          strIngredient4,
          strIngredient5,
        ];
        // console.log(Ingredients);
        const NewCocktail = {
          id,
          type,
          img,
          name,
          category,
          Instructions,
          Ingredients,
          glass,
        };
        // console.log(NewCocktail);
        setCocktails(NewCocktail);
      } else {
        setCocktails([]);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  }, [id]);

  useEffect(() => {
    FetchingData();
  }, [id, FetchingData]);

  if (loading) {
    return <Loading />;
  }
  if (!cocktails) {
    return <h1 className="h1">Unknown error occured</h1>;
  }
  const { name, img } = cocktails;
  return (
      <section className="section-sigle">
        <h1 className="h1-single">{name}</h1>
        <div className="outside-section">
          <Article {...cocktails} setIsClicked={setIsClicked} />
        </div>
        <div className="btn-center">
          <button className="btn-details">
            <Link to="/" className="link-back-home">
              Back to Home
            </Link>
          </button>
        </div>
        <aside
          className={`${
            isClicked
              ? "overlay-of-image-container show-overlay"
              : "overlay-of-image-container"
          }`}
        >
          <div className="inside-overlay-container">
            <img src={img} alt="" className="overlay-image" />
            <button onClick={() => setIsClicked(false)} className="btn-cross">
              <ImCross />
            </button>
          </div>
        </aside>
      </section>
  );
};

export default SingleCocktail;
